import {
  isDefinedString,
  isNullOrUndefined,
  isPositiveNumber,
  reduce
} from "et3-type-guards";
import i18n from "../constants/i18n";
import { DEFAULT_ET3_PICKER_SINGLE_VALUE } from "../constants/picker-entries-constants";
import {
  TEt3PickerMultipleValue,
  TEt3PickerOption,
  TEt3PickerSingleValue,
  TEt3PickerValue
} from "../TypesNEW";

export const reducerToNoneIfUndefined = (value: string) => {
  if (!isDefinedString(value.trim())) {
    return "NONE";
  }
  return value;
};

export const reducerToEmptyStringIfUndefined = (value: string) => {
  if (!isDefinedString(value.trim())) {
    return " ";
  }
  return value;
};

export const reducerToZeroIfUndefined = (value: number) => {
  if (!isPositiveNumber(value)) {
    return 0;
  }
  return value;
};

export const reducerToStringArray = (array: TEt3PickerMultipleValue) => {
  return array.map((row) => {
    return row.value;
  });
};

export const pickerEmptyValueReducer = (
  value: TEt3PickerValue
): TEt3PickerValue => {
  // Case 1: null or undefined
  if (isNullOrUndefined(value)) return [];

  // Case 2: array value
  if (Array.isArray(value)) {
    return value.filter((v) => !(v.label === "" && v.value === ""));
  }

  // Case 3: single value
  return value;
};

export const getPickerOptionLabel = (option: TEt3PickerOption) =>
  reduce(() => option.label, "") || i18n.get("KHATTABAT_MATCHING_ANY");

export const getPickerSelectedOption = (
  options: TEt3PickerOption[],
  value: TEt3PickerSingleValue
): TEt3PickerOption => {
  const selectedValue = reduce(() => value.value, "");
  return reduce(
    () => options.find((option) => option.value === selectedValue),
    DEFAULT_ET3_PICKER_SINGLE_VALUE
  );
};
